import { Component , OnInit} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AgentService } from '../agent.service';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/core/api/account.service';
import { CompanyService } from 'src/app/shared/companyservice/company.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-content-agent',
  templateUrl: './app-content-agent.component.html',
  styleUrls: ['./app-content-agent.component.scss']
})
export class AppContentAgentComponent implements OnInit {
  // userLogin: string | null = null;
  // selectedCountry: string = '';
  // selectedCountries: string[] = [];
  selectedCountries: string[] = []; // Stores selected countries
  // countries: string[] = ['Tunisia', 'Senegal', 'Morocco']; // List of countries
  countries: string[] = [];
  dropdownOpen = false; // Controls the dropdown's open/close state
  agentCountry: string | null = null;
  statuses: string[] = ['SCHEDULED', 'NOANSWER', 'NEW','DEFAULT']; // Preferred statuses
  selectedStatuses: string[] = [];
  dropdownOpenStatus: boolean = false;
  companies: any[] = []; // Stores the list of companies
  filteredCompanies: any[] = []; // Stores the filtered list based on search query
  searchQuery: string = ''; // Stores the current search query
  dropdownOpenCompany: boolean = false; // New flag for company dropdown
  selectedCompanyId: any;
  selectedCompanyName: any;
  phoneNumberSearchQuery: string | null = null;
  private searchQuerySubscription: Subscription;
  leads: any[] = [];
  errorMessage: string | null = null;
  private navigationSubscription: Subscription;
  isExpanded:  boolean = false;
  expandedLeadId: number | null = null;
  leadHistories: { [key: number]: any[] } = {};
  isLoadingNextLead: boolean = false;
  selectedCompanies: any[] = []; 
  daysAgo: number | null = null;
  displayDaysAgo: string = '';
  filterDateActive: boolean = false;
  isApplied = false;
  agentStatus: any;
  displayDateRange: string = '';
  constructor(private router: Router ,  private agentService: AgentService,private accountService: AccountService , private companyService : CompanyService ) { }
  
  private countryCodeMap: { [key: string]: string } = {
    Tunisia: 'TN',
    Senegal: 'SN',
    'Ivory-Coast': 'CI',
    Morocco: 'MA',
  };
  
  toggleDropdown(type: 'country' | 'status'): void {
    if (type === 'country') {
      this.dropdownOpen = !this.dropdownOpen; // Toggle country dropdown
      if (this.dropdownOpen) {
        this.dropdownOpenStatus = false; // Ensure status dropdown is closed
      }
    } else if (type === 'status') {
      this.dropdownOpenStatus = !this.dropdownOpenStatus; // Toggle status dropdown
      if (this.dropdownOpenStatus) {
        this.dropdownOpen = false; // Ensure country dropdown is closed
      }
    }
  }
  
// Handle the selection of statuses
onStatusToggle(status: string, isChecked: boolean): void {
  if (status === 'DEFAULT' && isChecked) {
    // If "default" is selected, reset selectedStatuses to empty
    this.selectedStatuses = [];
    sessionStorage.removeItem('selectedStatuses'); // Clear selected statuses from sessionStorage
  } else if (isChecked) {
    // If any other status is selected, set selectedStatuses to the chosen status
    this.selectedStatuses = [status];
    sessionStorage.setItem('selectedStatuses', JSON.stringify(this.selectedStatuses)); // Save selected status to sessionStorage
  }

  console.log('Selected Statuses:', this.selectedStatuses);
}
  

  onCountryToggle(country: string, isChecked: boolean) {
    if (isChecked) {
      // Add the country if it's checked and not already selected
      if (!this.selectedCountries.includes(country)) {
        this.selectedCountries.push(country);
      }
    } else {
      // Remove the country if it's unchecked
      this.selectedCountries = this.selectedCountries.filter(c => c !== country);
    }
    
     // Save selected countries to sessionStorage after each update
  sessionStorage.setItem('selectedCountries', JSON.stringify(this.selectedCountries));

  }


  private leadSubscription: Subscription;


  ngOnInit(): void {
 // Subscribe to the phone number search query observable
this.searchQuerySubscription = this.agentService.getPhoneNumberSearchQuery().subscribe(query => {
  this.phoneNumberSearchQuery = query;
  console.log('Received phoneNumberSearchQuery:', this.phoneNumberSearchQuery);
  // If the phone number query is non-empty, call the search method
if (this.phoneNumberSearchQuery?.trim()) {
  this.agentService.searchLeadByPhoneNumber(this.phoneNumberSearchQuery).subscribe(
    (response) => {
      console.log('Lead search by phone number result:', response);
      // Check if the response contains the "message" key (indicating no lead found)
      if (response && response.message) {
        this.errorMessage = response.message; // Set the error message
        this.leads = []; // Ensure the leads array is empty 
      } else {
        this.errorMessage = null; // Clear any previous error message
        this.leads = Array.isArray(response) ? response : [response];// Set the leads data
      }
    },
    (error) => {
      console.error('Error while searching lead by phone number:', error);
      this.errorMessage = 'An unexpected error occurred. Please try again.';
      this.leads = []; // Ensure the leads array is empty
    }
  );
} else {
  this.errorMessage = null; // Reset error message when no search is performed
  this.leads = []; // Clear leads data
}
});
// Clear search results on route change
this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe(() => {
    this.agentService.resetPhoneNumberSearchQuery(); // Reset service state
  });
    this.fetchCompaniesForTunisia();
    this.agentService.getAgentCountry().subscribe(
      (country) => {
        this.agentCountry = country;
        console.log('Retrieved Agent Country in Content Component:', this.agentCountry);
        // Split the agentCountry string by commas to populate the countries array
        if (this.agentCountry) {
          this.countries = this.agentCountry.split(',');
        }
      }
    );
    // this.getUserData();
    // Check sessionStorage for any previously selected countries on initialization
    const savedCountries = sessionStorage.getItem('selectedCountries');
    if (savedCountries) {
      this.selectedCountries = JSON.parse(savedCountries);
    }
    const savedStatuses = sessionStorage.getItem('selectedStatuses');
if (savedStatuses) {
  this.selectedStatuses = JSON.parse(savedStatuses);
}
// Retrieve company details from sessionStorage
// const savedCompanyId = sessionStorage.getItem('selectedCompanyId');
const savedCompanyName = sessionStorage.getItem('selectedCompanyName');
const savedSelectedCompanies = sessionStorage.getItem('selectedCompanies');
// if (savedCompanyId) {
//   this.selectedCompanyId = JSON.parse(savedCompanyId);
// }
if (savedCompanyName) {
  this.searchQuery = JSON.parse(savedCompanyName);
}
if (savedSelectedCompanies) {
    this.selectedCompanies = JSON.parse(savedSelectedCompanies);
}
      // Add a document click listener when the component mounts
    document.addEventListener('click', this.onDocumentClick.bind(this));
     // Add a document click listener when the component mounts
  document.addEventListener('click', this.onDocumentClickStatus.bind(this));
  document.addEventListener('click', this.onDocumentClickCompany.bind(this));

const storedFilterActive = sessionStorage.getItem('filterDateActive');
const storedDaysAgo = sessionStorage.getItem('daysAgo');
const storedApplied = sessionStorage.getItem('isApplied'); 
const savedDisplayDaysAgo = sessionStorage.getItem('displayDateRange');
if (storedFilterActive !== null) {
    this.filterDateActive = storedFilterActive === 'true';
}

if (storedDaysAgo !== null) {
    this.daysAgo = Number(storedDaysAgo);
    this.displayDateRange =savedDisplayDaysAgo;
} else if (this.filterDateActive) {
    this.daysAgo = 0; 
}

this.isApplied = storedApplied === 'true';
if (this.daysAgo ===0 || this.daysAgo===null){
  this.displayDateRange ="Today"
}else {
  this.displayDateRange;
}
  }

  ngOnDestroy() {
    // Remove the document click listener when the component unmounts
    document.removeEventListener('click', this.onDocumentClick.bind(this));
    // Remove the document click listener when the component unmounts
  document.removeEventListener('click', this.onDocumentClickStatus.bind(this));
  document.removeEventListener('click', this.onDocumentClickCompany.bind(this));
  // Unsubscribe to prevent memory leaks
  if (this.searchQuerySubscription) {
    this.searchQuerySubscription.unsubscribe();
  }
  }

  openLeadDetails(leadId: string) {
    // Check if at least one country is selected
    if (this.selectedCountries.length === 0) {
      alert('Please select at least one country first.');
      return;
    }
  
    // Proceed with navigation if a country is selected
    this.router.navigate(['/agent/editlead'], { queryParams: { leadreference: leadId } });
  }  

  // toggleHistory(leadId: number): void {
  //   this.expandedLeadId = this.expandedLeadId === leadId ? null : leadId; // Expand/collapse the clicked row
  //   console.log(
  //     this.expandedLeadId ? `Expanded section for Lead ID: ${leadId}` : `Collapsed section for Lead ID: ${leadId}`
  //   );
  // }
  toggleHistory(leadId: number, fbLeadReference: string): void {
    if (this.expandedLeadId === leadId) {
      // Collapse if already expanded
      this.expandedLeadId = null;
    } else {
      // Expand and fetch history
      this.expandedLeadId = leadId;

      // Check if the history for this lead has already been fetched
      if (!this.leadHistories[leadId]) {
        console.log(`Fetching history for Lead ID: ${leadId} (Reference: ${fbLeadReference})`);

        this.agentService.getLeadHistoryForSearchResults(fbLeadReference).subscribe({
          next: (data: any) => {
            console.log(`History fetched for Lead ID: ${leadId}`, data);
        
            if (data?.message && !data?.history) {
              // Handle the case where no history exists
              this.leadHistories[leadId] = null; // Set to null explicitly
            } else {
              // Process the raw data and format dates
              this.leadHistories[leadId] = data.map((history: any) => {
                // Check if createdAt is a valid date before conversion
                if (history.createdAt) {
                  const date = new Date(history.createdAt);
                  history.createdAt = isNaN(date.getTime()) ? null : date; // Set to null if invalid
                } else {
                  history.createdAt = null; // Explicitly handle missing dates
                }
                return history;
              });
            }
          },
          error: (err) => {
            console.error(`Failed to fetch history for Lead ID: ${leadId}`, err);
            this.leadHistories[leadId] = []; // Prevent repeated calls
          },
        });
      }
    }
  }
   // New method to fetch companies for Tunisia
    // Method to fetch companies
  fetchCompaniesForTunisia(): void {
    this.companyService.fetchCompaniesForTunisia().subscribe(
      (companies) => {
        this.companies = companies;
        this.filteredCompanies = companies; // Initially, show all companies
      },
      (error) => {
        console.error('Error fetching companies:', error);
      }
    );
  }

  onSearch(): void {
    if (!this.searchQuery.trim()) {
      // Clear the sessionStorage if the search query is empty
      // sessionStorage.removeItem('selectedCompanyId');
      // sessionStorage.removeItem('selectedCompanyName');
      sessionStorage.removeItem('selectedCompanies');
    }
    this.filteredCompanies = this.companies.filter(company =>
      company.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
    this.dropdownOpenCompany = this.filteredCompanies.length > 0 && this.searchQuery.length > 0;
  }

  // selectCompany(company: any): void {
  //   console.log('Selected Company ID:', company.id);
  //   this.selectedCompanyId = company.id;
  //   this.searchQuery = company.name;
  //   this.filteredCompanies = [];
  //   this.dropdownOpenCompany = false; // Close the dropdown after selecting
  //  // Save both the company ID and name in sessionStorage
  // sessionStorage.setItem('selectedCompanyId', JSON.stringify(this.selectedCompanyId));
  // sessionStorage.setItem('selectedCompanyName', JSON.stringify(this.searchQuery));
  // }

  // Method to select a company
  selectCompany(company: any): void {
    console.log('Selected Company ID:', company.id);
    this.selectedCompanyId = company.id; // Store the ID of the selected company
    this.searchQuery = '';
    // this.filteredCompanies = []; 
    // this.dropdownOpenCompany = false; 

    // Add company to selectedCompanies if not already in the list
    if (!this.selectedCompanies.some(c => c.id === company.id)) {
      this.selectedCompanies.push(company);
    }
    console.log('Current List of Selected Companies:', this.selectedCompanies);
    // Save both the company ID (last selected) and name in sessionStorage
    // sessionStorage.setItem('selectedCompanyId', JSON.stringify(this.selectedCompanyId));
    // sessionStorage.setItem('selectedCompanyName', JSON.stringify(this.searchQuery));

    // Save the list of selected companies in sessionStorage as well
    sessionStorage.setItem('selectedCompanies', JSON.stringify(this.selectedCompanies));
    // this.dropdownOpenCompany = true;
  }
 

  // Method to remove a company from the selected list
  removeCompany(company: any): void {
    this.selectedCompanies = this.selectedCompanies.filter(c => c.id !== company.id);
    sessionStorage.setItem('selectedCompanies', JSON.stringify(this.selectedCompanies));
  }

  // Close the dropdown if the user clicks outside of the company search dropdown
  // onDocumentClickCompany(event: MouseEvent): void {
  //   const target = event.target as HTMLElement;
  //   const searchInput = document.querySelector('#company-search');
  //   const dropdownContent = document.querySelector('.dropdown-content');

  //   if (
  //     this.dropdownOpenCompany && // Only close if the dropdown is open
  //     searchInput && dropdownContent &&
  //     !searchInput.contains(target) && // Click outside of the input field
  //     !dropdownContent.contains(target) // Click outside of the dropdown list
  //   ) {
  //     this.dropdownOpenCompany = false; // Close the dropdown
  //   }
  // }

  onDocumentClickCompany(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const searchInput = document.querySelector('#company-search');
    const dropdownContent = document.querySelector('.dropdown-content');
    if (searchInput && dropdownContent) {
        // Check if the click is inside the search input
        if (searchInput.contains(target)) {
            this.dropdownOpenCompany = true; // Open the dropdown when clicked inside
        } else if (this.dropdownOpenCompany) {
            // Close the dropdown if clicked outside of both
            this.dropdownOpenCompany = false;
        }
    }
}

  navigateToNextLead(): void {
    const startTime = performance.now();
 // Check if at least one country is selected before proceeding
 if (this.selectedCountries.length === 0) {
  console.warn('No country selected.');
  alert('Please select at least one country first.');
  return;
}

// Map selected country names to their respective codes
const selectedCountryCodes = this.selectedCountries.map(country => this.countryCodeMap[country]);
console.log("Mapped country codes:", selectedCountryCodes);

let selectedStatuses = this.selectedStatuses;
console.log("Selected statuses:", selectedStatuses);
// Expand the statuses array to include "PENDING_CONFIRMATION" when "NEW" is selected
 selectedStatuses = this.selectedStatuses.reduce((acc: string[], status) => {
  if (status === 'NEW') {
    acc.push(status, 'PENDING_CONFIRMATION'); // Add both "NEW" and "PENDING_CONFIRMATION"
  } else {
    acc.push(status); // Add other statuses as-is
  }
  return acc;
}, []);
console.log("Final selected statuses sent to backend:", selectedStatuses);
// Save selected countries to sessionStorage (optional, uncomment if needed)
// sessionStorage.setItem('selectedCountries', JSON.stringify(this.selectedCountries));
const companyId = this.selectedCompanyId || JSON.parse(sessionStorage.getItem('selectedCompanyId') || 'null');
const listOfCompanies = this.selectedCompanies || JSON.parse(sessionStorage.getItem('selectedCompanies') || 'null');
const companyIdsFromTheList = listOfCompanies ? listOfCompanies.map(company => company.id) : [];
console.log("your final list of companies selected",companyIdsFromTheList);
this.isLoadingNextLead = true;
let daysRangeToBackend = Number(sessionStorage.getItem('daysAgo')) || (this.filterDateActive ? this.daysAgo : null);
console.log("actual date range passed", daysRangeToBackend);
const apiCallStartTime = performance.now();
this.agentService.getNextLead(selectedCountryCodes, selectedStatuses,companyIdsFromTheList,daysRangeToBackend).subscribe(
  (data) => {
    const apiCallEndTime = performance.now();
    console.log(`API call took ${apiCallEndTime - apiCallStartTime} ms`);
    console.log("Response received from backend:", data);

    if (data && data !== 'No leads available for now refresh later') {
      console.log('Lead data received:', data);

      // Construct the URL using the received lead reference
      const url = `/agent/editlead?leadreference=${data}`;

      // Navigate to the constructed URL
      console.log("Navigating to URL:", url);
      this.router.navigateByUrl(url);
    } else if (data === 'No leads available for now refresh later') {
      // Stay on the current page and alert the user
      console.warn('No leads available.');
      alert('No leads available for now, please refresh later.');
    } else {
      console.warn('No lead reference received.');
    }
    this.isLoadingNextLead = false;
  },
  (error) => {
    console.error('Failed to load next lead:', error);
    this.isLoadingNextLead = false;
  }
);
  }


  // getUserData(): void {
  //   this.accountService.get().subscribe(
  //     (data) => {
  //       // Check if the user has a ROLE_AGENT authority
  //       const isAgent = data.authorities.some((auth: any) => auth.name === 'ROLE_AGENT');
        
  //       if (isAgent) {
  //         this.userLogin = data.login;
  //         console.log('User login:', this.userLogin);  // Log it to the console
  //       } else {
  //         console.log('No ROLE_AGENT found in authorities');
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching user data:', error);
  //     }
  //   );
  // }


 // Document click handler to close country dropdown if clicked outside
 onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;
  const dropdownButton = document.querySelector('.dropdown-button');
  const dropdownContent = document.querySelector('.dropdown-content');

  if (
    this.dropdownOpen && // Only check when dropdown is open
    dropdownButton &&
    dropdownContent &&
    !dropdownButton.contains(target) &&
    !dropdownContent.contains(target)
  ) {
    this.dropdownOpen = false; // Close the dropdown
  }
}

// Document click handler to close the status dropdown if clicked outside
onDocumentClickStatus(event: MouseEvent): void {
  const target = event.target as HTMLElement;

  const statusDropdownButton = document.querySelector('.dropdown-button-status') as HTMLElement;
  const statusDropdownContent = document.querySelector('.dropdown-content-status') as HTMLElement;

  if (
    this.dropdownOpenStatus && // Only check when the status dropdown is open
    statusDropdownButton &&
    statusDropdownContent &&
    !statusDropdownButton.contains(target) && // Click is outside the button
    !statusDropdownContent.contains(target)   // Click is outside the dropdown content
  ) {
    this.dropdownOpenStatus = false; // Close the status dropdown
  }
}



updateRange() {
  this.daysAgo = this.daysAgo !== null ? Number(this.daysAgo) : null;

  if (this.daysAgo !== null) {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - this.daysAgo);
    // this.displayDaysAgo = this.daysAgo === 0 
    // ? 'Today' 
    // :  this.displayDateRange ;
    this.daysAgo === 0 ? this.displayDateRange ='Today' :this.displayDateRange =`${startDate.toLocaleDateString()} - ${today.toLocaleDateString()}`;
  } else {
    this.displayDaysAgo = 'No date filter applied';
  }

  console.log('Selected Days Ago:', this.daysAgo);
  this.isApplied = false;
  sessionStorage.setItem('isApplied', 'false');
}

  toggleFilter() {
    if (this.filterDateActive) {
        this.daysAgo = 0;
    } else {
        this.daysAgo = -1;
        sessionStorage.removeItem('filterDateActive');
        sessionStorage.removeItem('daysAgo');
        sessionStorage.removeItem('displayDateRange');
    }
    this.updateRange();
}

submitRange() {
  if (this.filterDateActive && this.daysAgo !== null) {
      sessionStorage.setItem('filterDateActive', String(this.filterDateActive));
      sessionStorage.setItem('daysAgo', String(this.daysAgo));
      sessionStorage.setItem('displayDateRange', String(this.displayDateRange));
      this.isApplied = true;
      sessionStorage.setItem('isApplied', 'true');
      this.fetchAgentStatus();
  }
}
  
fetchAgentStatus() {
  this.agentService.getLeadsStatusForAgents(this.daysAgo).subscribe(
    (status) => {
      console.log('Agent status:', status);
      this.agentStatus = status;
    },
    (error) => {
      console.error('Error fetching agent status:', error);
    }
  );
}

}
